import {
  ChakraProvider,
  Box,
  Heading,
  Text,
  Grid,
  Badge,
  Flex,
  Divider,
} from '@chakra-ui/react';

import { Row, Col, Card, Typography, Table, Tag, Progress } from 'antd';
import { BackButton } from '../components/TopSection/ExportButton';

const { Title } = Typography;

const tableData = [
  {
    key: '1',
    fator: 'Demandas psicológicas',
    instrumento: 'COPSOQ III',
    indicador: '42%',
    prob: 'Elevada',
    sev: 'Moderada',
    classificacao: 'RELEVANTE',
  },
];

const columns = [
  { title: 'Fator', dataIndex: 'fator', key: 'fator' },
  { title: 'Instrumento', dataIndex: 'instrumento', key: 'instrumento' },
  { title: 'Indicador', dataIndex: 'indicador', key: 'indicador' },
  { title: 'Prob.', dataIndex: 'prob', key: 'prob' },
  { title: 'Sev.', dataIndex: 'sev', key: 'sev' },
  {
    title: 'Classificação',
    dataIndex: 'classificacao',
    key: 'classificacao',
    render: (text: string) => <Tag color="orange">{text}</Tag>,
  },
];

function AreaCard({ title, value1, value2, value3 }: any) {
  return (
    <Card title={title}>
      <Text mb={1}>Fadiga visual</Text>
      <Progress percent={value1} style={{ marginBottom: 10 }} />

      <Text mb={1}>Risco TIC</Text>
      <Progress percent={value2} style={{ marginBottom: 10 }} />

      <Text mb={1}>Demandas</Text>
      <Progress percent={value3} style={{ marginBottom: 10 }} />

      <Tag color="red">ALTO</Tag>
    </Card>
  );
}

export default function RiskMatrixPage({ OnBack }: any) {
  const cells = [
    '#d9f7be',
    '#fff1b8',
    '#ffd591',
    '#ffa39e',
    '#b7eb8f',
    '#ffe58f',
    '#ffbb96',
    '#ff7875',
    '#95de64',
    '#ffd666',
    '#ff9c6e',
    '#ff4d4f',
    '#73d13d',
    '#ffc53d',
    '#ff7a45',
    '#f5222d',
  ];

  // <Badge
  //               bg="brand-orange.400"
  //               w="2"
  //               h="2"
  //               borderRadius="full"
  //               position="absolute"
  //               bottom="50%"
  //             />

  return (
    <ChakraProvider>
      <Box bg="gray.50" minH="100vh" p={10} marginTop={20} position="relative">
        {/* HEADER */}

        <Box position="absolute" top={10} marginBottom={20}>
          <BackButton OnBack={OnBack} />
        </Box>

        <Flex justify="space-between" align="center" mb={6} mt={20}>
          <Box>
            <Text
              fontSize="sm"
              color="blue.500"
              maxWidth="auto"
              marginBottom={5}
            >
              DOCUMENTO TÉCNICO — PGR / NR-1
            </Text>
            <Heading size="lg">Matriz de Risco Psicossocial</Heading>
            <Heading size="lg" color="blue.500" fontWeight="bold">
              TechCorp
            </Heading>
            <Text fontSize="sm" color="gray.400" maxWidth="auto" marginTop={5}>
              Base integrada: COPSOQ III · RED/TIC · NR-17 · PHQ-9 · GAD-7 | JAN
              2026
            </Text>
          </Box>

          <Box textAlign="right" color="gray.600">
            <Text fontSize="sm">Classificação resultante</Text>
            <Flex align="center">
              <Text fontSize="sm">Probabilidade:</Text>
              <Text fontSize="sm" ml={2} fontWeight="bold">
                {' '}
                Elevada
              </Text>
            </Flex>
            <Flex align="center">
              <Text fontSize="sm">Severidade:</Text>
              <Text fontSize="sm" ml={2} fontWeight="bold">
                {' '}
                Moderada
              </Text>
            </Flex>
            <Badge colorScheme="orange" p={2} mt={2}>
              RISCO RELEVANTE
            </Badge>
          </Box>
        </Flex>

        <Divider mt="4" mb="8" />

        <Flex align="end" mb={8}>
          <Text color="gray.600" fontSize="sm" w="auto" whiteSpace="nowrap">
            01 Critérios da Matriz
          </Text>
          <Divider mt="4" mb="2" ml="4" />
        </Flex>

        {/* ESCALAS */}
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={12}>
            <Card title="Escala de Probabilidade">
              <Text>Baixa — &lt; 20%</Text>
              <br />
              <Text>Moderada — 20%–39%</Text>
              <br />
              <Text>Elevada — 40%–59%</Text>
              <br />
              <Text>Muito elevada — ≥ 60%</Text>
            </Card>
          </Col>

          <Col span={12}>
            <Card title="Escala de Severidade">
              <Text>Leve — impacto reversível</Text>
              <br />
              <Text>Moderada — sintomas frequentes</Text>
              <br />
              <Text>Elevada — prejuízo ocupacional</Text>
              <br />
              <Text>Crítica — afastamentos</Text>
            </Card>
          </Col>
        </Row>

        {/* MATRIZ */}
        <Card
          title="Matriz Probabilidade × Severidade"
          style={{ marginBottom: 24 }}
        >
          <Row gutter={[8, 8]}>
            {cells.map((color, i) => (
              <Col span={6}>
                <div
                  style={{
                    height: 80,
                    background: color,
                    borderRadius: 8,
                  }}
                />
              </Col>
            ))}
          </Row>
        </Card>

        {/* TABELA */}
        <Card
          title="Fatores de Risco Consolidados"
          style={{ marginBottom: 24 }}
        >
          <Table dataSource={tableData} columns={columns} pagination={false} />
        </Card>

        {/* ÁREAS */}
        <Grid templateColumns="repeat(3, 1fr)" gap={6}>
          <AreaCard
            title="Tecnologia da Informação"
            value1={73}
            value2={62}
            value3={58}
          />

          <AreaCard
            title="Atendimento ao Cliente"
            value1={65}
            value2={54}
            value3={48}
          />

          <AreaCard
            title="Comercial e Vendas"
            value1={71}
            value2={67}
            value3={35}
          />
        </Grid>
      </Box>
    </ChakraProvider>
  );
}
